import script from "./GlassModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlassModal.vue?vue&type=script&setup=true&lang=ts"

import "./GlassModal.vue?vue&type=style&index=0&id=eeda16b2&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeda16b2"]])

export default __exports__